import Aether from './../assets/svg/SimboloAether.svg';
import Sensacional from './../assets/svg/LogoSDM.svg';
import XYZL from './../assets/svg/LogoXYZ.svg';

const screenWidths = {
  lg: 768,
  sm: 320
};

const bizUnits = ['SDM', 'XYZ', 'AET'];

const BIZ_UNITS_MAP = {
  SDM: 'Sensacional Dinamica Mexicana',
  XYZ: 'XYZ Taller',
  AET: 'AETHER',
};

const BIZ_UNITS_MAP_IMG = {
  SDM: Sensacional,
  XYZ: XYZL,
  AET: Aether,
};

export default {
  screenWidths,
  BIZ_UNITS_MAP,
  bizUnits,
  BIZ_UNITS_MAP_IMG
};



// WEBPACK FOOTER //
// ./src/utils/constants.js